module.exports = __webpack_public_path__ + "assets/media/dots-about.85febefd.svg";